import { useParams } from "react-router-dom";
import ProcedurePage from "./ProcedurePage";
import GuidePage from "./GuidePage";
import NotFound from "./NotFound";
import { PROCEDURE_ROUTES, SAMPLE_PROCEDURE } from "../data/procedures";
import { GUIDE_ROUTES } from "../data/guides";

const PROCEDURE_SLUGS = new Set([
  SAMPLE_PROCEDURE.slug,
  ...Object.values(PROCEDURE_ROUTES).flat().map((p) => p.slug),
]);
const GUIDE_SLUGS = new Set(GUIDE_ROUTES.map((g) => g.slug));

// Resolves a top-level :slug to the correct template (procedure / guide / 404).
export default function SlugResolver() {
  const { slug } = useParams();
  if (PROCEDURE_SLUGS.has(slug)) return <ProcedurePage />;
  if (GUIDE_SLUGS.has(slug)) return <GuidePage />;
  return <NotFound />;
}
